import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

// The radio button fieldset itself:
export const audienceField = {
  label: 'Audience label',
  id: 'audience'
};

// Individual radio button options:
export const audienceOptions = {
  school: {
    label: 'School, early years or youth group',
    id: 'school',
    testId: 'payinAudienceSchool'
  },
  work: {
    label: 'Workplace',
    id: 'workplace',
    testId: 'payinAudienceWork'
  },
  public: {
    label: 'Myself or a group',
    id: 'myself-or-group-payin-audience',
    testId: 'payinAudienceMyselfOrGroup'
  },
};

export const getRules = () => ({
  [audienceField.id]: yup
    .string()
    .required('Please select an audience to continue'),
});

export const getFormSchema = () => (
  yup.object().shape(getRules())
);

export const getFormResolver = () => (
  yupResolver(getFormSchema())
);
